var DropDowns = {
    productDoms: null,
    DD_TYPE: {
        YEARS:"dd_years",
        MAKES:"dd_makes",
        MODELS:"dd_models",
        SUB_MODELS:"dd_subModels",
        FINAL_RESULTS:"finalResults"
    },

    init: function() {
        this.buildDD(this.DD_TYPE.YEARS, null);
        this.buildHandlers();

    },

    buildHandlers: function() {
        var _this = this;
        _this.getProducts = $.proxy(this, "getProducts");

        // click dd
        $(".dd_productsMenu").change(function(e) {
            $('#results').addClass('fade-out').removeClass('fade-in');

            _this.getProducts($(e.currentTarget).attr('id'));
            console.log("%c"+$(e.currentTarget).attr('id')+" sadfasdASFD "+e.currentTarget.value, "background-color: yellow");

            // SET HASH
            var params = {
                y: ($("#year").val()),
                mk: ($("#make").val()),
                mo: ($("#model").val()),
                ss: ($("#submodel").val())
            }

            if (params.y != null) {
                var newHash = '#y='+params.y;
                for(var item in params){
                    if(item != 'y' && params[item] && params[item] != "null") {
                        newHash += '&'+item+'='+params[item];
                    }
                }
                location.hash = Deeplink.oldHash = newHash;
            }
        });
    },

    displayContent: function(params) {
      if ($("#submodel").is(':hidden')) {
          if (Parser.filteredChoices.year && Parser.filteredChoices.make && Parser.filteredChoices.model) {
              // display output
              DropDowns.buildResults(params);
          }
      } else {
        if (Parser.filteredChoices.year && Parser.filteredChoices.make && Parser.filteredChoices.model && Parser.filteredChoices.subModel) {
            // display output
            DropDowns.buildResults(params);
        }
      }
    },

    lowerCaseDashString: function(str) {
        return (str).replace(/\s+/g, '-').replace('&', '-').toLowerCase();
    },

    resortArrays: function(__ref){
      var _this = this;
      // sorting, first split category into seperate arrays
      var categoryOrderRef = ["Truck & Tow Brake Performance Upgrade", "Street Performance", "Daily Driver Upgrade", "OE Replacement Brakes"],
          subCategoryOrderRef = ["Brake Pad & Rotor Kits with Calipers", "Brake Pad & Rotor Kits", "Brake Rotors", "Brake Pads"],
          sortedCategories = _this.breakApartArrays(__ref, "productCategory");

      // next split seperate arrays into subcategories and tie them back together
      for(var arr in sortedCategories){
        var sortedSubCategories = _this.breakApartArrays(sortedCategories[arr], "productSubCategory");
        sortedCategories[arr] = _this.recombineArrays(sortedSubCategories, subCategoryOrderRef);
      }

      return _this.recombineArrays(sortedCategories, categoryOrderRef)
    },

    breakApartArrays: function(__array, __entry){
      var sortedObject = {};
      for (var item in __array){
        item = __array[item];
        console.log("wut", item, __entry)
        sortedObject[item[__entry].toLowerCase()] = sortedObject[item[__entry].toLowerCase()] || [];
        sortedObject[item[__entry].toLowerCase()].push(item);
      }
      return sortedObject;
    },

    recombineArrays: function(__array, __arrayOrderRef){
      var newArray = [];
      //recombine categories in order
      //loop through the subcategory order
      for(var i = 0, orderRef; orderRef = __arrayOrderRef[i]; i++){
        //attach to the array if it exists
        if(__array[orderRef.toLowerCase()]) {
            newArray = newArray.concat(__array[orderRef.toLowerCase()]);
            delete __array[orderRef.toLowerCase()];
        }
      }

      //reattach any remaining unspecified items
      for(var item in __array){
        console.warn("no categories/subcategories found for [" ,item, "], pushing to the end of the list");
        newArray = newArray.concat(__array[item]);
      }
      return newArray;
    },

    buildResults: function(params) {
        var _this = this;
        $('#results').removeClass('fade-out').addClass('fade-in');

        var relatedItems = [];
        var params2 = {};

        // maps array to object with key and value
        for(var item in params) {
          params2[params[item].id] = params[item].val;
        }

        // call api
        Parser.filterResults(Parser.FILTER_TYPE.YEARS, params2.year);
        Parser.filterResults(Parser.FILTER_TYPE.MAKES, params2.make);
        Parser.filterResults(Parser.FILTER_TYPE.MODELS, params2.model);
        Parser.filterResults(Parser.FILTER_TYPE.SUB_MODELS, params2.submodel);

        for(var item in Parser.results){
            relatedItems.push(Parser.results[item]);
        }
        //sorting relatedItems into proper categories
        relatedItems = _this.resortArrays(relatedItems);
        console.log("new sorted items",relatedItems)

        params.products = relatedItems;

        // vehicle name
        var vehicleName = decodeURIComponent(params2.year + ' ' + params2.make + ' ' +  params2.model + ' ' + params2.submodel);
        $('.vehicle-name').text(vehicleName.replace('undefined', '').replace('null', ''));

        // clear html container
        $('.section-container').html('');

        // parsing into categories & subcategories
        var sortedProducts = {};
        for (var item in params.products) {
            item = params.products[item];
            // combing category and subcategory into ids and pushing
            var categoryID = item.productCategory+'{|}'+item.productSubCategory;
            // presetting
            sortedProducts[categoryID] = sortedProducts[categoryID] || [];
            sortedProducts[categoryID].push(item);
        }

        console.log('>>>', sortedProducts);

        for (var item in sortedProducts) {
            var html = '';
            var categoryCombo = item.split("{|}");
            // creating headings based of product category and sub category combo
            html += '<div class="section '+ _this.lowerCaseDashString(categoryCombo[0]) +'">';
                html += '<div class="heading1">';
                    html += '<div class="heading1-category '+ _this.lowerCaseDashString(categoryCombo[0]) +'">'+categoryCombo[0]+'</div>';
                    html += '<div class="heading1-subcategory">'+categoryCombo[1]+'</div>';
                html += '</div>';
                html += '<div class="heading2">';
                    html += '<div class="heading2-product">product</div>';
                    html += '<div class="heading2-desc">description</div>'
                html += '</div>';

            // looping through arrays in each category+subcategory combo
            for (var productItem in sortedProducts[item]){
                productItem = sortedProducts[item][productItem];
                var productName = productItem.product;
                    html += '<div class="row">';
                        // product
                        html += '<div class="row-product">'
                            // name
                            html += '<div class="row-product-name">';
                              html += '<strong>' + productName + '</strong>';
                              // html += '<div>by Power Stop</div>';
                            html += '</div>';
                            // position
                            html += '<div class="row-product-position">';
                              html += '<strong>Position: </strong>';
                              html += '<span>' + productItem.position + '</span>';
                              html += '<div class="row-product-position-image ' + _this.lowerCaseDashString(productItem.position) + '"></div>';
                            html += '</div>';
                        html += '</div>';
                        // description
                        html += '<div class="row-description">';
                            html += '<strong class="mobile-only">Description</strong>&bull;&nbsp;';
                            html += productItem.description;
                        html += '</div>';
                        // part
                        html += '<div class="row-part">';
                          html += '<strong>Part #: </strong>';
                          html += '<div>' + productItem.part + '</div>';
                          // position - for mobile
                          html += '<div class="row-product-position">';
                            html += '<strong>Position: </strong>';
                            html += '<span>' + productItem.position + '</span>';
                            html += '<div class="row-product-position-image '  + _this.lowerCaseDashString(productItem.position) + '"></div>';
                          html += '</div>';
                          // button
                          html += '<div class="row-button">';
                              html += '<a class="button" href="http://walmart.com/ip/' + productItem.productURL + '" target="_blank">';
                                html += '<strong>Buy Now</strong>';
                                html += '<div>on Walmart.com</div>';
                              html += '</a>';
                          html += '</div>';
                        html += '</div>';
                        // image
                        html += '<div class="row-image">';
                          html += '<img src="https://embed.widencdn.net/img/powerstop/' + productItem.embedID + '/640px/' + productItem.part + '.jpeg">';
                        html += '</div>';
                        // button
                        html += '<div class="row-button">';
                            html += '<a class="button" href="http://walmart.com/ip/' + productItem.productURL + '" target="_blank">';
                              html += '<strong>Buy Now</strong>';
                              html += '<div>on Walmart.com</div>';
                            html += '</a>';
                        html += '</div>';
                    html += '</div>';
            }
            html += '</div>';
            $('.section-container').append(html);
        }
    },

    getProducts:function(__targetID, __val){
        var dd_type = __targetID == "model" ? this.DD_TYPE.SUB_MODELS : __targetID == "make" ? this.DD_TYPE.MODELS : __targetID == "submodel" ? this.DD_TYPE.FINAL_RESULTS : this.DD_TYPE.MAKES;

        if (!__val) {
            __val = $('#'+__targetID).val();
        }
        this.buildDD(dd_type, decodeURIComponent(__val));

        if (!Parser.parserReady) {
            return;
        }

        var resultsRef = [];
        for (var t in Parser.results) {
            var result = (Parser.results[t]["product"].toLowerCase());
            if (resultsRef.indexOf(result)==-1){
                resultsRef.push(result);
            }
        }
    },

    // builds dropdown values
    buildDD:function(__type, __val){
        var _this = this;
        var ddHTML = '', dd_initialPool = [], tar = '', disabledDDs = [];

        // selecting appropriate filter pools, targets, disabled menus, etc
        switch(__type){
          case this.DD_TYPE.YEARS:
            disabledDDs = ["#year","#model", "#submodel", "#make"];
            Parser.dd_years.sort();
            for(var i=Parser.dd_years.length-1; i>=0; i--){
              if(!$("#dd_years_"+Parser.dd_years[i]).length)
               ddHTML += '<option id="dd_years_'+Parser.dd_years[i]+'" value="'+Parser.dd_years[i]+'">'+Parser.dd_years[i]+'</option>';
            }
            $('#year').removeClass("disabled");
            $('#year').append(ddHTML);
            return;
          break;
          case this.DD_TYPE.MAKES:
            filterBy = Parser.FILTER_TYPE.YEARS,
            tar = '#make',
            disabledDDs = [{tar:"#model", defaultTxt:"Model"}, {tar:"#submodel", defaultTxt:"Sub Model"}, {tar:"#make", defaultTxt:"Make"}];
          break;
          case this.DD_TYPE.MODELS:
            filterBy = Parser.FILTER_TYPE.MAKES,
            tar = '#model',
            disabledDDs = [{tar:"#model", defaultTxt:"Model"}, {tar:"#submodel", defaultTxt:"Sub Model"}];
          break;
          case this.DD_TYPE.SUB_MODELS:
            filterBy = Parser.FILTER_TYPE.MODELS,
            tar = '#submodel',
            disabledDDs = [{tar:"#submodel", defaultTxt:"Sub Model"}];
          break;
          case this.DD_TYPE.FINAL_RESULTS:
            console.log("FINALU");
            filterBy = Parser.FILTER_TYPE.SUB_MODELS;
          break;
          default:
            console.log("INVALID DROPDOWN TYPE, USE Products.DD_TYPE types");
            return;
          break;
        }

        // disabling appropriate dropdowns and breaking out of operations according to the requested dropdown
        // if(tar != '' && tar) $(tar).html('<option value="">'+defaultTxt+'</option>');
        for(var item in disabledDDs) {
            $(disabledDDs[item].tar).addClass("disabled");
            $(disabledDDs[item].tar).html('<option value="">Select '+disabledDDs[item].defaultTxt+'</option>');
        }

        //filtering approriately
        Parser.filterResults(filterBy, __val);
        if(!Parser[__type] || Parser[__type].length == 0 || Parser[__type][0] == ""){
            if(__type == this.DD_TYPE.SUB_MODELS){
                $(tar).css("display","none");
            } else {
                console.log(__type,"no dropdown values or first value in dropdown is invalid")
            }
            return;
        }

        //populating
        Parser[__type].sort();
        for(var i = 0; i < Parser[__type].length; i++){
            ddHTML += '<option value="'+encodeURIComponent(Parser[__type][i])+'">'+Parser[__type][i]+'</option>';
        }

        //enabling and appending options
        if (tar != '' && tar) {
            $(tar).removeClass("disabled");
            $(tar).append(ddHTML);
            $("#submodel").css("display","initial");
        }
    }
}
